/** Curated hiring segment labels/descriptions (mirrors backend job_segments seed). */

export const SEGMENT_LABELS: Record<string, string> = {
  bpo_ops: "BPO Operations",
  healthcare: "Healthcare",
  ops_logistics: "Operations & Logistics",
  tech: "Tech",
  sales: "Sales",
  bfsi: "Banking, Financial Services & Insurance",
  hr_admin: "HR & Admin",
  creative: "Creative",
  edu_hospitality: "Education & Hospitality",
  manufacturing: "Manufacturing",
};

export const SEGMENT_DESCRIPTIONS: Record<string, string> = {
  bpo_ops: "Voice, chat, and email support, IT helpdesk, and back-office process roles",
  healthcare: "Healthcare admin support, medical billing/coding, and clinical operations roles",
  ops_logistics: "Warehouse, logistics, supply chain, and e-commerce operations roles",
  tech: "Software development, QA, DevOps, data, and cybersecurity roles",
  sales: "Inside sales, field sales, business development, and retail sales roles",
  bfsi: "Banking, insurance, and financial back-office operations roles",
  hr_admin: "HR, recruiting, payroll, and office administration roles",
  creative: "Graphic design, UI/UX, content writing, and digital marketing roles",
  edu_hospitality: "Teaching, edtech, hotel/hospitality, and food & beverage roles",
  manufacturing: "Production, quality control, and field technician/service roles",
};

/** Flat Select/MultiSelect options from static labels (fallback before catalog loads). */
export const SEGMENT_OPTIONS = Object.entries(SEGMENT_LABELS).map(([value, label]) => ({
  value,
  label,
  description: SEGMENT_DESCRIPTIONS[value],
}));

export function segmentLabel(code: string, labels?: Record<string, string>): string {
  return labels?.[code] ?? SEGMENT_LABELS[code] ?? code;
}

export function segmentDescription(code: string): string | undefined {
  return SEGMENT_DESCRIPTIONS[code];
}

export const SEGMENT_SELECT_COPY = {
  selectAll: "Select all",
  clearAll: "Clear",
  hireForLabel: "Segments you hire for",
  hireForDescription:
    "Pick the segments you hire for. This cannot be changed later — only an admin can update it.",
  recruitForLabel: "Segments you recruit for",
  recruitForDescription:
    "Pick the segments you recruit for. This cannot be changed later — only an admin can update it.",
  requiredError: "Select at least one segment",
  nothingFound: "No matching segments",
  adminTitle: "Segments",
  adminEdit: "Edit",
  adminSave: "Save segments",
  adminSaved: "Segments updated",
  empty: "—",
} as const;
